/**
 * Copyright IBM Corp. 2022, 2026
 */

import { liteClient as algoliasearch } from 'algoliasearch/lite'

export const APP_ID = 'YY0FFNI7MF'
export const API_KEY = '3615ee8741704fe3f36c18efcf248c71'

export const searchClient = algoliasearch(APP_ID, API_KEY)
